import React, { FC } from 'react';
import { getNCFilesByProductionOperationId } from '@reducers/manufacture';
import { updateHeaderConfig } from '@reducers/details';
import { connect } from 'react-redux';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { useJobDetails } from '@v2/pages/common/hooks/useJobDetails';
import { getProductionBatchByProductionOperationId, operationsSearch } from '@reducers/search';
import JobContentWrapper from '@v2/pages/job/common/components/JobContentWrapper';
import MultiMachineTimeline from '@v2/pages/common/components/MultiMachineTimeline';
import { useRoute } from '@react-navigation/native';
import { isRouteParamTruthy } from '@helpers';

interface JobDetailsJobsTimelineProps {

}

const JobDetailsJobsTimelineComponent: FC<JobDetailsJobsTimelineProps> = ({
  updateHeaderConfig,
  operationsSearch,
  getNCFilesByProductionOperationId,
  getProductionBatchByProductionOperationId,
}) => {
  const title = useTitle();

  useJobDetails({
    updateHeaderConfig,
    operationsSearch,
    getNCFilesByProductionOperationId,
    getProductionBatchByProductionOperationId,
  });

  const route = useRoute();

  const keepList = route?.params?.keepList;
  const shouldDisplayFullScreenTimeline = !isRouteParamTruthy(keepList);

  return (
    <JobContentWrapper loading={false} title={title.job}>
      <MultiMachineTimeline fullScreen={shouldDisplayFullScreenTimeline}  />
    </JobContentWrapper>
  );
};

const JobDetailsJobsTimeline = connect(null, {
  updateHeaderConfig,
  operationsSearch,
  getNCFilesByProductionOperationId,
  getProductionBatchByProductionOperationId,
})(JobDetailsJobsTimelineComponent);

export { JobDetailsJobsTimeline };
